import { API_URL, PLATFORM_FEE, URL, TAX } from './config';

import { AJAX } from './helper';

export const state = {
  user: {},
  shop: [],
  products: [],
  product: {},
  order: {
    single: {},
    cart: {},
    session: {},
  },
  cart: {},
  query: {
    orders: {},
    order: {},
  },
};

const createUserObject = user => {
  state.user = {
    name: user.name,
    email: user.email,
    id: user._id,
    ...(user.role && { role: user.role }),
    ...(user.photo && { photo: user.photo }),
    ...(user.mobile && { mobile: user.mobile }),
  };
};

const createSingleOrderObj = (order, session) => {
  state.order.single = {
    id: order._id ? order._id : order.id,
    size: order.size,
    brand: order.brand,
    tag: order.tag,
    imageCover: order.imageCover,
    slug: order.slug,
  };
  if (session) {
    // const { brand, tag, imageCover, slug } = order;
    // const { price, mrp, platformFee, tax } = session.notes;
    state.order.single.mrp = session.notes.mrp;
    state.order.single.price = session.notes.price;
    state.order.single.platformFee = session.notes.platformFee;
    state.order.single.tax = session.notes.tax;
    state.order.single.currency = session.currency;
    state.order.single.amount = Math.round(session.amount / 100);
    state.order.session = session;
  }

  if (!session) {
    // const { brand, tag, imageCover, slug, price, mrp, size } = order;
    state.order.single.mrp = order.mrp;
    state.order.single.price = order.price;
    state.order.single.tax = (order.price * TAX) / 100;
    state.order.single.amount = Math.round(
      order.price + state.order.single.tax,
    );
    state.order.single.platformFee = 0;
    state.order.single.currency = 'INR';
  }
};

export const loadUser = async function () {
  try {
    const data = await AJAX('get', `${API_URL}users/me`);

    const user = data.data.user;

    createUserObject(user);
  } catch (err) {
    throw err;
  }
};

// loadUser();

export const signupUser = async signupData => {
  try {
    if (signupData.password !== signupData.passwordConfirm)
      throw new Error('Password and Confirm Password do not match.');

    const data = await AJAX('post', `${API_URL}users/signup`, signupData);

    const user = data.data.user;

    createUserObject(user);
  } catch (err) {
    throw err;
  }
};

export const loginUser = async loginData => {
  try {
    const data = await AJAX('post', `${API_URL}users/login`, loginData);

    const user = data.data.user;

    createUserObject(user);
  } catch (err) {
    throw err;
  }
};

export const logoutUser = async () => {
  const data = await AJAX('get', `${API_URL}users/logout`);

  return data;
};

export const updateUser = async userData => {
  try {
    const data = await AJAX('patch', `${API_URL}users/updateMe`, userData);

    const user = data.data.updatedUser;

    createUserObject(user);
  } catch (err) {
    throw err;
  }
};

export const updatePassword = async passData => {
  try {
    if (passData.password !== passData.passwordConfirm)
      throw new Error('New password and confirm password should be same.');
    const data = await AJAX(
      'patch',
      `${API_URL}users/updateMyPassword`,
      passData,
    );

    const user = data.data.user;

    createUserObject(user);
  } catch (err) {
    throw err;
  }
};

export const forgotPassword = async email => {
  try {
    const data = await AJAX('post', `${API_URL}users/forgotPassword`, email);

    return data;
  } catch (err) {
    throw err;
  }
};

export const resetPassword = async (token, newPass) => {
  try {
    const { password, passwordConfirm } = newPass;

    if (password !== passwordConfirm)
      throw new Error('New password and confirm password should be same.');

    if (password.length < 8)
      throw new Error('Password should be minimum 8 characters.');

    const data = await AJAX(
      'patch',
      `${API_URL}users/resetPassword/${token}`,
      newPass,
    );
  } catch (err) {
    throw err;
  }
};

export const loadShop = async () => {
  try {
    const products = await AJAX('get', `${API_URL}products`);

    state.shop = products.data.products;
  } catch (err) {
    throw err;
  }
};

export const loadProduct = async slug => {
  try {
    const data = await AJAX('get', `${API_URL}products/${slug}`);
    const product = data.data.product;
    state.product = product;
  } catch (err) {
    throw err;
  }
};

export const loadOrders = async () => {
  try {
    const data = await AJAX('get', `${API_URL}orders`);

    // if (!orders) throw new Error('No orders');
    state.query.orders = data.data.orders;
  } catch (err) {
    throw err;
  }
};

export const loadOrder = async id => {
  try {
    const data = await AJAX('get', `${API_URL}orders/${id}`);

    // if (!orders) throw new Error('No orders');
    state.query.order = data.data.order;
  } catch (err) {
    throw err;
  }
};

export const loadAdminOrder = async id => {
  try {
    const data = await AJAX('get', `${API_URL}admin/orders/${id}`);

    // if (!orders) throw new Error('No orders');
    state.query.order = data.data.order;
  } catch (err) {
    throw err;
  }
};

export const loadAdminOrderList = async query => {
  try {
    // Converting objec to query string
    const queryStr = query
      ? Object.keys(query)
          .map(el => {
            if (query[el]) return `${el}=${query[el]}`;
          })
          .filter(el => el !== undefined)
          .join('&')
      : ``;

    const data =
      query instanceof PointerEvent // if form is to be submitted then it will handle
        ? ``
        : await AJAX('get', `${API_URL}admin/orders/?${queryStr}`);

    if (!data) return;

    state.query.orders = data.data.orders;
  } catch (err) {
    throw err;
  }
};

export const updateAdminOrder = async newData => {
  try {
    // const data = { ...newData };

    Object.keys(newData).forEach(el => (newData[el] ? `` : delete newData[el]));

    if (newData.paymentMethod === 'cod') {
      if (
        (newData.status === 'paid' && !newData.paidIn) ||
        (newData.status !== 'paid' && newData.paidIn)
      ) {
        throw new Error(
          '"Status" and "Paid Using" both values should be available.',
        );
      }

      if (
        (newData.deliveryStatus === 'delivered' &&
          !newData.status &&
          state.query.order.status !== 'paid') ||
        (newData.deliveryStatus === 'delivered' &&
          newData.status &&
          newData.status !== 'paid' &&
          state.query.order.status !== 'paid')
      ) {
        throw new Error(
          'If Delivery Status is "Delivered", then Status should be "paid".',
        );
      }
    }
    if (newData.deliveryStatus === 'delivered') delete newData.expectedDelivery;
    if (
      newData.status === 'paid' &&
      newData.paidIn &&
      !newData.deliveryStatus &&
      !state.query.order.deliveryStatus
    )
      newData.deliveryStatus = 'order accepted';

    const data = await AJAX(
      'patch',
      `${API_URL}admin/orders/${state.query.order._id}`,
      newData,
    );

    state.query.order = data.data.order;
  } catch (err) {
    throw err;
  }
};

export const uploadProduct = async productData => {
  try {
    const data = await AJAX('postProduct', `${API_URL}products`, productData);
    const { newProduct } = data.data;
    // const product = data.data.product;
    // state.product = product;

    return newProduct;
  } catch (err) {
    throw err;
  }
};

export const loadAdminProductList = async query => {
  try {
    // Converting objec to query string
    const queryStr = query
      ? Object.keys(query)
          .map(el => {
            if (query[el]) return `${el}=${query[el]}`;
          })
          .filter(el => el !== undefined)
          .join('&')
      : ``;

    const data =
      query instanceof PointerEvent // if form is to be submitted then it will handle
        ? ``
        : await AJAX('get', `${API_URL}admin/products/?${queryStr}`);

    if (!data) return;

    state.shop = data.data.products ? data.data.products : [data.data.product];
  } catch (err) {
    throw err;
  }
};

export const loadAdminProduct = async id => {
  try {
    const data = await AJAX('get', `${API_URL}admin/products/${id}`);
    state.product = data.data.product;
  } catch (err) {
    throw err;
  }
};

export const editProduct = async (productData, id) => {
  try {
    const data = await AJAX(
      'patchProduct',
      `${API_URL}products/${id}`,
      productData,
    );

    state.product = data.data.product;
  } catch (err) {
    throw err;
  }
};

export const createSingleOrder = async size => {
  try {
    // 1) get product

    const data = await AJAX(
      'post',
      `${API_URL}orders/single/${state.product.id}`,
      { size },
    );

    const newOrder = data.data.newOrder;

    createSingleOrderObj(newOrder);
  } catch (err) {
    throw err;
  }
};

export const addShipAddress = async (
  orderData,
  validateAddress = true,
  createSession = true,
) => {
  try {
    if (validateAddress) {
      if (
        !orderData.add1 ||
        !orderData.dist ||
        !orderData.mobile ||
        !orderData.pin ||
        !orderData.state
      )
        throw new Error('Fill address correctly.');
    }

    if (createSession) {
      if (!orderData.size) throw new Error('Select Size');
      if (!orderData.paymentOption) throw new Error('Select payment option');

      if (orderData.paymentOption === 'online') {
        const session = await AJAX(
          'post',
          `${API_URL}orders/checkout-session/${state.order.single.id}`,
        );

        createSingleOrderObj(state.order.single, session);
      }
    }
    if (orderData.paymentOption)
      state.order.single.payMethod = orderData.paymentOption;

    if (validateAddress) {
      state.order.single.shipAddress = `${orderData.add1},
   ${orderData.add2 ? ` ${orderData.add2}.` : ''}
   Dist/City: ${orderData.dist}
   State: ${orderData.state}
   Contact: ${orderData.mobile}`;
      state.order.single.mobile = orderData.mobile;
    }

    if (orderData.price && +orderData.price !== state.order.single.price)
      state.order.single.price = +orderData.price;

    if (orderData.size && orderData.size !== state.order.single.size)
      state.order.single.size = orderData.size;
  } catch (err) {
    throw err;
  }
};

export const payNow = async session => {
  const options = {
    key: session.notes.key, // Replace with your Razorpay key_id
    amount: session.amount, // *
    currency: session.currency, // *
    name: 'Pragya Enterprises', // *
    description: 'For every student, every classroom. Real uniforms.',
    image: 'https://www.pragya.enterprises/images/favicon.png',
    order_id: session.id, // * This is the order_id created in the backend
    callback_url: `${URL}orders`, // Your success URL
    // prefill: {
    //   name: 'Your Name',
    //   email: 'your.email@example.com',
    //   contact: '+919999999999', // country code is mandatory
    // },
    // theme: {
    //   color: '#F37254',
    // },

    handler: async function (session) {
      try {
        const data = await AJAX('post', `${API_URL}orders/checkout`, {
          razorpay_order_id: session.razorpay_order_id,
          razorpay_payment_id: session.razorpay_payment_id,
          razorpay_signature: session.razorpay_signature,

          order: state.order.single,
        });

        if (data.status !== 'ok')
          throw new Error('Payment verification failed');

        window.location.href = '/orders';
      } catch (err) {
        console.error('Error:', err);
        throw new Error('Error verifying payment');
      }
    },
  };
  const rzp = new Razorpay(options);
  rzp.open();
};

export const payNowCash = async (order, reload = true) => {
  try {
    const data = await AJAX('post', `${API_URL}orders/cashCheckout`, order);

    if (data.status === 'ok' && reload) {
      window.location.href = '/orders';
    }
    if (data.status === 'ok' && !reload) {
      state.order.single = data.data.order;
      state.query.order = data.data.order;
    }
  } catch (err) {
    throw err;
  }
};
